import * as React from 'react';
import { questionErrorMessage } from '../../../../../../constants/applicationMessage';

export interface IUploadImageProps {
    label?: string;
    subLabel?: string;
    hasMultiImages?: boolean;
    images?: any[];
    image?: string;
    error: any;
    disabled: boolean;
    toggleImageModal?: (imageURL: string) => void;
    onEdit: () => void;
    onDelete?: (index: number) => void;
    handleOptionLabel?: (data: any, event: any) => void;
    hideLabel?: boolean;
}

const UploadImage: React.FC<IUploadImageProps> = (props) => (
    <div className="row">
        {!props.hideLabel && (
            <div className="col-md-12 form-group-header">
                {props.label || 'Upload Image'}
                <span>{props.subLabel}</span>
            </div>
        )}
        <div className="col-md-12 form-group">
            <div className={`${!props.hideLabel ? 'video-content' : ''}`}>
                <div
                    className={`video-content__manual${
                        props.hasMultiImages ? '__multi' : ''
                    }`}
                >
                    {!props.image && (
                        <span
                            className="form-group__icon form-group__icon--large"
                            onClick={props.onEdit}
                        >
                            <i className="nx nx-image-mb"></i>
                            <span
                                className={`nx-option-edit icon-lg ${
                                    props.disabled ? 'disabled' : ''
                                }`}
                            >
                                {' '}
                                <i className="nx nx-edit"></i>{' '}
                            </span>
                        </span>
                    )}
                    <UploadedImage {...props} />
                    {props.image && props.error ? (
                        <span className="form-group__error-msg">
                            {props.error && props.error.optionCard}
                        </span>
                    ) : null}
                </div>
            </div>
        </div>
    </div>
);

const UploadedImage = (props) => {
    if (props.hasMultiImages && props.images.length) {
        return props.images.map((image, index) => {
            const showError =
                props.error.options &&
                props.error.options[index] &&
                props.error.options[index].label;
            return (
                <span
                    className="form-group__icon form-group__icon--large"
                    key={'option-' + index}
                    title={'Click it to expand the image'}
                >
                    <img
                        className=""
                        src={image.mediaURL}
                        onClick={
                            props.toggleImageModal &&
                            props.toggleImageModal(image.mediaURL)
                        }
                    />

                    <input
                        className={`form-group__control ${
                            showError ? 'error' : ''
                        }`}
                        type="text"
                        value={image.label}
                        placeholder="Please add label here"
                        onChange={(event) =>
                            props.handleOptionLabel(index, event.target.value)
                        }
                    />

                    <span
                        className={`nx-option-edit icon-lg ${
                            props.disabled ? 'disabled' : ''
                        }`}
                        onClick={props.onDelete(index)}
                    >
                        {' '}
                        <i className="nx nx-close"></i>{' '}
                    </span>
                </span>
            );
        });
    } else if (props.image) {
        return (
            <>
                <span className="form-group__icon form-group__icon--large">
                    <img
                        className=""
                        src={props.image}
                        onClick={
                            props.toggleImageModal &&
                            props.toggleImageModal(props.image)
                        }
                    />
                    <span
                        className={`nx-option-edit icon-lg ${
                            props.disabled ? 'disabled' : ''
                        }`}
                        onClick={props.onEdit}
                    >
                        {' '}
                        <i className="nx nx-edit"></i>{' '}
                    </span>
                </span>
                {props.error && props.error.mediaURL ? (
                    <span className="form-group__error-msg">
                        {questionErrorMessage.REQUIRED}
                    </span>
                ) : null}
            </>
        );
    } else return null;
};
export default UploadImage;
